import { render, staticRenderFns } from "./Infographic.vue?vue&type=template&id=358830c1&lang=pug&"
import script from "./Infographic.vue?vue&type=script&lang=js&"
export * from "./Infographic.vue?vue&type=script&lang=js&"
import style0 from "./Infographic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports